import axios from 'axios';
import { useRouter } from 'next/router';
import React, { useContext, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { IdleTimerProvider } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { resetState } from '../store/Slicer/AccessSlice';
import { resetCustBillState } from '../store/Slicer/CustomerBillRetrieve';
import { resetCustomerState } from '../store/Slicer/CustomerSlicer';
import { LogoutUserState } from '../store/Slicer/UserSlice';
import { resetPGState } from '../store/Slicer/PGSlice';
import { resetAccountandbilling } from '../store/Slicer/accountandBliingSlice';
import { msalInstance1 } from '../services/msal';
const IdleTimerContainer = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.user);
  const { MobileNum, AuthSelectedUser } = useSelector(
    (state) => state.GetAccess?.user
  );
  const { CustID } = useSelector((state) => state.GetAccess?.Authpresets);
  const { AdminUser_email } = useSelector(
    (state) => state.GetAccess?.Adminuser
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const router = useRouter();
  const innerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);

  const onIdle = () => {
    setModalIsOpen(true);
    sessionTimeoutRef.current = setTimeout(logOut, 60000);
  };

  const extendSession = () => {
    setModalIsOpen(false);
    clearTimeout(sessionTimeoutRef.current);
  };
  var brn = '';
  const getLastLoginData = async () => {
    try {
      const res = await fetch(
        `/bizcareui/api/getLoginHistory?user=${AuthSelectedUser}`,
        {
          method: 'GET',
          headers: {
            // Authorization: Buffer.from(AuthSelectedUser).toString('base64'),
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.json();
      brn = data.result[0]?.CUSTOMER_ID;
      logoutDataDetailsUpdate(brn);
    } catch (error) {
      console.error(error);
    }
  };
  const logoutDataDetailsUpdate = async (brn) => {
    var payload = {
      MOBILE_NO: MobileNum,
      TRANS_TYPE: 'SIGN OUT',
      TRANS_DESCRIPTION: 'Sign out successfully',
      BRN_NUMBER: brn,
      LoginId: AuthSelectedUser,
    };
    try {
      const res = await fetch(`/bizcareui/api/updateUserLoginHistory`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const Loginresult = await res.json();
      if (Loginresult?.result === 'Login Details Updated Successfully') {
        setModalIsOpen(false);
        clearTimeout(sessionTimeoutRef.current);
        /*  deleteCookie("AUTHTOKEN");
        deleteCookie("AUTHKEY");
        deleteCookie("AUTHTOKEN2");
        deleteCookie("AUTHKEY2"); */
        dispatch(resetAccountandbilling());

        dispatch(resetState());
        dispatch(resetCustomerState());
        dispatch(resetCustBillState());
        dispatch(resetPGState());
        dispatch(LogoutUserState());
        console.log('inside logout in timer1');
        for (var key in window.sessionStorage) {
          if (key.indexOf('msal') != -1) {
            window.sessionStorage.removeItem(key);
          }
        }
        const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

        //  window.location.reload(true);
        window.sessionStorage.clear();
      }
    } catch (error) {
      console.error(error);
      dispatch(resetState());
      dispatch(resetCustomerState());
      dispatch(resetCustBillState());
      dispatch(resetAccountandbilling());
      dispatch(resetPGState());
      dispatch(LogoutUserState());
      for (var key in window.sessionStorage) {
        if (key.indexOf('msal') != -1) {
          window.sessionStorage.removeItem(key);
        }
      }
      const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
      //  router.push('/');
    }
    router.push('/');
  };

  const logoutDataUpdate = async () => {
    var payload = {
      MOBILE_NO: MobileNum,
      TRANS_TYPE: 'SIGN OUT',
      TRANS_DESCRIPTION: 'Sign out successfully',
      BRN_NUMBER: CustID,
      LoginId: AuthSelectedUser,
    };
    try {
      const res = await fetch(`/bizcareui/api/updateUserLoginHistory`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const Loginresult = await res.json();
      if (Loginresult?.result === 'Login Details Updated Successfully') {
        setModalIsOpen(false);
        clearTimeout(sessionTimeoutRef.current);
        /*   deleteCookie("AUTHTOKEN");
        deleteCookie("AUTHKEY");
        deleteCookie("AUTHTOKEN2");
        deleteCookie("AUTHKEY2"); */
        // alert("inside logout in timer2");
        console.log('inside logout in timer2');
        dispatch(resetState());
        dispatch(resetCustomerState());
        dispatch(resetAccountandbilling());

        dispatch(resetCustBillState());
        dispatch(resetPGState());
        for (var key in window.sessionStorage) {
          if (key.indexOf('msal') != -1) {
            window.sessionStorage.removeItem(key);
          }
        }
        dispatch(LogoutUserState());
        const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

        // window.location.reload(true);
        window.localStorage.clear();

        // for (var key in window.sessionStorage) {
        //   if (key.indexOf('msal') != -1) {
        //     window.sessionStorage.removeItem(key);
        //   }
        // }
        router.push('/');
      }
    } catch (error) {
      console.error(error);
      dispatch(resetState());
      dispatch(resetCustomerState());
      dispatch(resetCustBillState());
      dispatch(resetAccountandbilling());

      dispatch(resetPGState());
      dispatch(LogoutUserState());
      for (var key in window.sessionStorage) {
        if (key.indexOf('msal') != -1) {
          window.sessionStorage.removeItem(key);
        }
      }
      const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

      // router.push('/');
    }
  };
  const AdminlogoutDataUpdate = async () => {
    var payload = {
      TRANS_TYPE: 'SIGN OUT',
      TRANS_DESCRIPTION: 'Sign out successfully',
      LoginId: AdminUser_email,
      MOBILE_NO: MobileNum,
    };

    try {
      const res = await fetch(`/bizcareui/api/updateAdminLoginData`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      const Loginresult = await res.json();
      if (Loginresult?.result === 'Login Details Updated Successfully') {
        setModalIsOpen(false);
        clearTimeout(sessionTimeoutRef.current);
        /* deleteCookie("AUTHTOKEN");
        deleteCookie("AUTHKEY");
        deleteCookie("AUTHTOKEN2");
        deleteCookie("AUTHKEY2"); */
        console.log('inside logout in timer3');
        dispatch(resetState());
        dispatch(resetAccountandbilling());
        window.sessionStorage.removeItem('loginType');
        window.sessionStorage.removeItem('msal.interaction.status');
        dispatch(resetCustomerState());
        window.localStorage.clear();
        // alert("inside logout in timer");
        for (var key in window.sessionStorage) {
          if (key.indexOf('msal') != -1) {
            window.sessionStorage.removeItem(key);
          }
        }
        dispatch(LogoutUserState());
        const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');

        //  window.location.reload(true);
      }
    } catch (error) {
      console.error(error);

      dispatch(resetState());
      dispatch(resetAccountandbilling());

      dispatch(resetCustomerState());
      window.sessionStorage.removeItem('loginType');
      window.sessionStorage.removeItem('msal.interaction.status');
      for (var key in window.sessionStorage) {
        if (key.indexOf('msal') != -1) {
          window.sessionStorage.removeItem(key);
        }
      }
      dispatch(LogoutUserState());
      const userdeletecookie = await axios.get('/bizcareui/api/auth/logout');
    }
    msalInstance1.logoutRedirect();
  };
  const logOut = () => {
    {
      user?.role === 'Admin'
        ? AdminlogoutDataUpdate()
        : CustID
        ? logoutDataUpdate()
        : getLastLoginData();
    }
    // {userLoggedIn === true ? (CustID ? logoutDataUpdate() : "") : getLastLoginData()}
  };

  return (
    <>
      <Modal show={modalIsOpen}>
        <Modal.Header>
          <Modal.Title> Session expire warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your session will expire in 1 minutes. Do you want to extend the
          session?
          {/* You will be Logged out soon */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="warning" onClick={() => logOut()}>
            Logout
          </Button>
          <Button variant="primary" onClick={() => extendSession()}>
            Extend session
          </Button>
        </Modal.Footer>
      </Modal>
      <IdleTimerProvider refs={innerRef} timeout={600000} onIdle={onIdle} />
    </>
  );
};

export default IdleTimerContainer;
